import { render, staticRenderFns } from "./xasesor.vue?vue&type=template&id=3bb299ac&scoped=true"
import script from "./xasesor.vue?vue&type=script&lang=js"
export * from "./xasesor.vue?vue&type=script&lang=js"
import style0 from "./xasesor.vue?vue&type=style&index=0&id=3bb299ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb299ac",
  null
  
)

export default component.exports